import {useCallback, useState} from 'react';

interface UseLoadingResult {
  loading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
}

export const useLoading = (): UseLoadingResult => {
  const [loading, setLoading] = useState(false);

  const startLoading = useCallback((): void => setLoading(true), []);
  const stopLoading = useCallback((): void => setLoading(false), []);

  return {loading, startLoading, stopLoading};
};
